// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__WXRPC","emails":"CreateEditClinics_emails__ZTEKK","emailTagLabel":"CreateEditClinics_emailTagLabel__3DOMm"};